<template>
  <div>
    <el-dialog
        v-if="currentUser"
        :before-close="close"
        :title="procedureData.user ? 'Редактирование записи' : 'Запись на приём'"
        :visible.sync="visible"
        width="600px"
        @open="onOpen"
    >

      <div class="title">Тип приема</div>
      <el-select
          v-loading="loadingMembership"
          class="select"
          v-model="procedureData.validate"
          placeholder="Тип приема"
      >
        <el-option
            label="Абонемент"
            :value="true"
        ></el-option>
        <el-option
            label="Единоразовое посещение"
            :value="false"
        ></el-option>
      </el-select>

      <template v-if="!procedureData.validate">
        <div class="title">Вид оплаты</div>
        <el-row :gutter="20">
          <el-col :span="procedureData.payment_method !== 'rubles' ? 24 : 12">
            <el-select
                v-loading="loadingPaymentTypes"
                v-model="procedureData.payment_method"
                class="select"
                placeholder="Выберите тип оплаты"
            >
              <el-option
                  v-for="item in paymentTypes"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"/>

            </el-select>
          </el-col>
          <el-col v-if="procedureData.payment_method === 'rubles'" :span="12">
            <el-input
                @input="autoFormat($event, procedureData)"
                v-model="procedureData.payment_value"
                class="select"
                placeholder="Введите сумму..."
            />
          </el-col>
        </el-row>
      </template>

      <el-row
          v-if="false"
          :gutter="30"
          class="client-data"
          justify="space-between"
          type="flex"
      >
        <el-col :span="8">
          <div class="client-data__title">Имя клиента</div>
          <div class="client-data__sub-title">{{ currentUser.name }}</div>
        </el-col>
        <el-col :span="8">
          <div class="client-data__title">Номер телефона</div>
          <div class="client-data__sub-title">{{ currentUser.phone }}</div>
        </el-col>
        <el-col :span="8">
          <div class="client-data__title">Бонусы</div>
          <a :href="`/users/${currentUser.id}`" target="_blank" class="client-data__sub-balance">
            {{ currentUser.balance }} H₵
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.125 9.5H13.875" stroke="#078065" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"/>
              <path d="M9.5 5.125L13.875 9.5L9.5 13.875" stroke="#078065" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </a>
        </el-col>
      </el-row>

      <user-settings-panel v-if="false" :user="currentUser"/>

      <div class="title">Выбор процедуры</div>

      <el-select
          v-if="!procedureData.user"
          v-model="appointmentForm.procedure"
          class="select"
          @change="getSlot"
      >
        <el-option
            v-for="tag in procedureTags"
            :key="tag.id"
            :label="tag.title"
            :value="tag.id"
        ></el-option>

      </el-select>
      <el-alert
          v-else
          :closable="false"
          class="noty-alert"
          title="При редактировании записи нет возможности изменять тип процедуры"
          type="warning"
      >
      </el-alert>

      <div class="title">Выбор даты</div>

      <el-date-picker
          v-model="appointmentForm.date"
          class="client-data__input"
          format="dd.MM.yyyy"
          placeholder="Выберите дату"
          type="date"
          @change="getSlot"
      />

      <div class="title">Выбор времени</div>

      <div v-if="appointmentForm.procedure" v-loading="loading">

        <el-row :gutter="20">
          <el-col :span="timeType === 1 ? 24 : 12">
            <el-select
                class="select"
                v-model="timeType"
                placeholder="Тип приема"
            >
              <el-option
                  label="Выбор временного слота"
                  :value="1"
              ></el-option>
              <el-option
                  label="Произвольный выбор времени"
                  :value="2"
              ></el-option>
            </el-select>
          </el-col>
          <el-col v-if="timeType === 2" :span="12">
            <el-time-select
                v-model="appointmentForm.time"
                :picker-options="pickerOptions"
                class="select"
                placeholder="Время начала процедуры"
                @change="timeType = 2"
                ref="customTimePicker"
                @focus="clickTimeType()"
            />
          </el-col>
        </el-row>

        <el-row v-if="timeType === 1" class="time-slots">
          <el-col :xs="24">
            <div v-for="(tag, index) of timeSlots" :key="index" class="time-slot">
              <input :id="`radio-${index}`" v-model="appointmentForm.timeSlot"
                     :disabled="!tag.available"
                     :value="tag.start"
                     checked
                     name="radio"
                     type="radio"
                     class="time-slot__input"
                     @change="timeType = 1">
              <el-tooltip
                  v-if="tag.description"
                  :content="tag.description"
                  effect="dark"
                  placement="top"
              >
                <label
                    :for="`radio-${index}`"
                    class="time-slot__label"
                    :style="tag.color ? { backgroundColor: tag.color } : {} ">
                  {{ tag.time }}
                </label>
              </el-tooltip>
              <label v-else
                     :for="`radio-${index}`"
                     :style="tag.color ? { backgroundColor: tag.color } : {}"
                     class="time-slot__label">
                {{ tag.time }}
              </label>
            </div>

          </el-col>
        </el-row>

      </div>
      <el-alert
          v-else
          :closable="false"
          class="noty-alert"
          show-icon
          title="Выберите процедуру"
          type="warning"
      >
      </el-alert>

      <footer-buttons mt>
        <el-button
            v-if="procedureData.user"
            :disabled="loading"
            :loading="loadSave"
            type="primary"
            @click="updateData"
        >Сохранить
        </el-button>
        <el-button
            v-else
            :disabled="loading"
            :loading="loadSave"
            type="primary"
            @click="saveData"
        >Сохранить
        </el-button>
        <el-button @click="close">Закрыть</el-button>
      </footer-buttons>

    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";

import UserSettingsPanel from "@/components/elements/UserSettingsPanel/Panel"
import FooterButtons from "@/components/dialog/FooterButtons"

export default {
  name: "AppointmentModal",
  data() {
    return {
      loading: true,
      loadingMembership: true,
      loadingPaymentTypes: true,
      loadingUser: true,
      appointmentForm: {
        date: this.$root.getDateTz(null, 'Europe/Moscow'),
        procedure: this.procedureId,
        timeSlot: null,
        time: null,
      },
      timeType: 1,
      paymentTypes: [],
      timeSlotsId: [],
      timeSlots: [],
      pollAnswers: [],
      loadSave: false,
    }
  },
  components: {
    UserSettingsPanel,
    FooterButtons
  },
  watch: {
    timeType(value) {
      if (value === 2) this.$nextTick(() => {
        this.$refs['customTimePicker'].focus()
      })
    },
    visible() {
      this.appointmentForm.procedure = this.procedureId
      this.appointmentForm.date = this.currentDate

      this.getSlot()
    },
  },
  props: {
    procedureData: {},
    visible: {
      required: true,
    },
  },
  computed: {
    ...mapGetters("appointment", {
      currentUser: "currentUser",
      currentDepartment: "currentDepartment",
      currentDate: "currentDate",
      appointment: "appointment",
    }),
    pickerOptions() {
      return this.timeSlots.length === 0
          ? {}
          : {
            start: this.timeSlots[0].time,
            step: "00:05",
            end: this.timeSlots[this.timeSlots.length - 1].time,
          };
    },
    procedureId() {
      return this.procedureData.procedure
          ? this.procedureData.procedure.id
          : null;
    },
    procedureTags() {
      return this.appointment.procedure;
    },
    dateEarlier() {
      return this.$root.timeIso(moment(this.procedureData.newStartDateObj).toDate());

    },
  },
  created() {
    // console.log("created");
  },
  filters: {},
  methods: {
    ...mapActions({
      closeModal: "appointment/CLOSE_MODAL_APPOINTMENT",
      getAppointment: "appointment/GET_APPOINTMENT",
    }),
    autoFormat(value, event) {
      event.payment_value = value.replace(",", ".");
    },
    multiple(num) {
      while (num % 5 !== 0) num++;
      return num;
    },
    updateData() {
      if (!this.appointmentForm.timeSlot && this.timeType === 1) {
        this.$notify.warning({
          title: "Укажите время...",
          message: "Выберите временной слот 😕",
        })
        return
      }
      let start = 0
      this.loadSave = true

      if (this.timeType === 1) start = this.appointmentForm.timeSlot;

      if (this.timeType === 2) start = this.$root.dateBack(this.appointmentForm.date) + "T" +
          this.appointmentForm.time



      this.$api.appointments
          .update(this.currentDepartment.id, this.procedureData.id, {
            start,
            payment_method: !this.procedureData.validate ? this.procedureData.payment_method : null,
            payment_value: !this.procedureData.validate ? this.procedureData.payment_value : null,
          })
          .then(() => {
            // this.$emit("move-event", status, targetData.start, targetData.end);

            this.$notify.success({
              title: "Удачно...",
              message: "Запись изменена",
            });

            this.close();
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка изменения 😕",
              message: response.response.data.message,
            })

            this.getSlot()
          })
          .finally(() => {
            this.getAppointment()
            this.loadSave = false
          })
    },
    saveData() {
      if (!this.appointmentForm.timeSlot && this.timeType === 1) {
        this.$notify.warning({
          title: "Укажите время...",
          message: "Выберите временной слот 😕",
        })
        return
      }

      let start = 0

      if (this.timeType === 1) start = this.appointmentForm.timeSlot
      if (this.timeType === 2)
        start =
            this.$root.dateBack(this.appointmentForm.date) +
            "T" +
            this.appointmentForm.time

      let data = {
        user_id: this.currentUser.id,
        procedure_id: this.appointmentForm.procedure,
        start: start,
        need_validation: this.procedureData.validate,
        payment_method: !this.procedureData.validate ? this.procedureData.payment_method : null,
        payment_value: !this.procedureData.validate ? this.procedureData.payment_value : null,
      }


      this.loadSave = true;
      this.$api.appointments
          .save(this.currentDepartment.id, data)
          .then(() => {
            this.$notify.success({
              title: "Успешно",
              message: "Запись сохранена!",
            });
            this.getAppointment();
            this.close();
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка сохранения данных 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loadSave = false;
          });
    },
    onOpen() {
    },
    clickTimeType() {

      if (this.appointmentForm.time) return

      let t = this.$root.getDateTz(null, 'Europe/Moscow');
      t.setMinutes(this.multiple(t.getMinutes()));
      this.appointmentForm.time = this.$root.timeIso(t);
      //
    },
    getMembership() {
      this.loadingMembership = true

      // Загрузка абонементов
      this.$api.membership
          .getByProcedure(this.currentUser.id, this.appointmentForm.procedure)
          .then(() => {
            // this.membership = response.data
            // if (response.data.length) this.procedureData.validate = true
          })
          .catch(() => {
            this.$notify.error({
              title: "Упс...",
              message: "Ошибка загрузки абонементов 😕",
            })
          })
          .finally(() => {
            this.loadingMembership = false
          })

    },
    getPaymentTypes() {
      this.loadingPaymentTypes = true

      // Загрузка списка типов оплат
      this.$api.appointments
          .paymentTypes()
          .then((response) => {
            this.paymentTypes = response.data
          })
          .catch(() => {
            this.$notify.error({
              title: "Упс...",
              message: "Ошибка загрузки списка типов оплат 😕",
            })
          })
          .finally(() => {
            this.loadingPaymentTypes = false
          })
    },
    getSlot() {
      if (!this.appointmentForm.procedure) return

      this.getMembership()
      this.getPaymentTypes()
      this.loading = true

      // Загрузка временые слотов
      this.$api.appointments
          .slot({
            departmentId: this.currentDepartment.id,
            procedureId: this.appointmentForm.procedure,
            user: this.currentUser.id,
            date: this.$root.dateBack(this.appointmentForm.date),
          })
          .then((response) => {
            this.timeSlots = response.data

            let index = this.timeSlots.findIndex(
                (e) => e.time === this.dateEarlier
            );
            if (index >= 0)
              this.appointmentForm.timeSlot = this.timeSlots[index].start
          })
          .catch(() => {
            this.$notify.error({
              title: "Упс...",
              message: "Ошибка загрузки временых слотов 😕",
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
    dateFor(d) {
      return moment(d).toDate()
    },
    close() {
      this.$emit("close");

      this.closeModal();
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  color: #606266;


  margin-top: 20px;
}

.client-data {
  margin: 24px 0;

  &__title {
    color: #111;

    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    margin: 0;
  }

  &__sub-title {
    font-size: 15px;
    line-height: 18px;
    letter-spacing: -0.015em;

    color: #111111;
    margin: 8px 0;
  }

  &__sub-balance {
    display: flex;
    align-items: center;

    font-size: 15px;
    line-height: 18px;
    letter-spacing: -0.015em;

    color: #078065;
    margin: 8px 0;

    text-decoration: none;
  }


  &__input {
    margin: 10px 0;
    width: 100%;
  }
}

.radio {
  margin: 15px 0;
  display: block;
}

.time-picker {
  width: 100%;
}

.noty-alert {
  margin: 5px 0;
}

.time-slots {
  margin-top: 16px;
}

.time-slot {
  display: inline-block;
  margin: 5px 5px 0 0;

  &__input[type=radio] {
    display: none;
  }

  &__label {
    display: inline-block;
    cursor: pointer;
    padding: 5px 8px;

    width: 33px;

    align-items: center;
    text-align: center;
    letter-spacing: 0.005em;

    color: #606266;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;


    background: #F8F9FA;
    box-shadow: none;

    border: 1px solid #E4E7ED;
    border-radius: 4px;
  }

  &__input[type=radio]:checked + label {
    background: #43D3B3;
    border: 1px solid #43D3B3;

    color: #fff;
  }

  &__label:hover {
    color: #666;
  }

  &__input[type=radio]:disabled + label {
    background: #FFD8D8;
    color: #666;
    cursor: not-allowed;

  }
}

.select {
  width: 100%;
  margin-top: 8px;
}

</style>
